module.exports = __webpack_public_path__ + "img/Resources 2.e842314b.jpeg";